export const Testimonial = () => (
  <section data-testid="testimonial-section" className="py-24 px-8 max-w-4xl mx-auto text-center">
    <div className="font-mono-tag text-xs tracking-[0.25em] text-[#9E7D4E] uppercase mb-4">
      Guest Verification
    </div>
    <blockquote
      data-testid="testimonial-quote"
      className="font-editorial text-3xl sm:text-4xl text-[#1A1A18] leading-tight mb-6"
    >
      "Incredible hospitality, very much recommended."
    </blockquote>
    <p
      data-testid="testimonial-author"
      className="font-mono-tag text-xs tracking-widest text-[#55524A] uppercase"
    >
      Jan Nel • Guesthouse Guest
    </p>
  </section>
);
